import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "phone"
})
export class PhonePipe implements PipeTransform {
  transform(rawNum: any) {
    return [
        '+',
        rawNum.slice(0, 1),
        ' ',
        '(',
        rawNum.slice(1, 4),
        ')',
        ' ',
        rawNum.slice(4, 7),
        ' ',
        rawNum.slice(7, 11),
      ].join('')
  }
}